<template>
  <div class="passport">
    <v-row>
      <v-col cols="12">
        <WarningAlert>
          <p
            class="mb-0 font-weight-bold"
            style="font-size: 20px; margin-bottom: 0;"
          >
            {{ registrationCards.length > 0 ? $t("memberRegistration.step7.content.alert_passport") : $t("membership.passport.title") }}
          </p>
        </WarningAlert>
      </v-col>
    </v-row>
    <v-row v-if="registrationCards.length > 0">
      <v-col cols="12">
        <p class="font-weight-medium">{{ $t("membership.passport.click_icon_see_card") }}</p>
      </v-col>
    </v-row>

    <v-row v-if="registrationCards.length > 0">
      <v-dialog v-model="viewRow" max-width="504px">
          <v-card class="mx-auto">
            <v-card-text class="bcard">
              <div id="printMe" style="display:none;">
                <div class="card" >
                  <div class="card-body" style="padding-left:10px; padding-right:10px;">
                    <v-row >
                      <v-col md="12" class="text-left">
                        <v-row style="position:relative">
                          <img src="@/assets/images/BackGroundImage.png" style="width:480px;display:inline;">
                          <v-col style="float:left;text-align:left;position:absolute;top:68px;left:20px;">
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.organization") }}</span>: {{membershipDataCard.organizationName}}</p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.membershipPeriod") }}</span>: {{membershipDataCard.membershipPeriod}} </p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.membershipNumber") }}</span>: {{membershipDataCard.membershipNumber}} </p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.name") }}</span>: {{membershipDataCard.name}} </p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.class") }}</span>: {{membershipDataCard.className}} </p>
                            <p v-if="membershipDataCard.raceNumber" style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.number") }}</span>: {{membershipDataCard.raceNumber}}</p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
              <v-row style="padding-top: 20px;">
                <v-col md="12" class="text-left" id="printMe1">
                  <v-row class="bg_row">
                    <v-col cols="12">
                      <v-row>
                        <v-col md="5" class="pb-0">
                          <p>{{ $t("membership.organization") }}: </p>
                        </v-col>
                        <v-col md="y" class="pb-0">
                          <p>{{membershipDataCard.organizationName}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.membershipPeriod") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.membershipPeriod}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.membershipNumber") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.membershipNumber}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.name") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.name}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("memberRegistration.step4.content.participant.racing_type") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.racingType}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.class") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.className}}</p>
                        </v-col>
                      </v-row>
                      <v-row v-if="membershipDataCard.raceNumber">
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.number") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.raceNumber}}</p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" class="text-right">
                  <v-btn @click="printCard" class="mr-2">{{ $t("yourRegistration.print") }}</v-btn>
                  <v-btn @click="closeDeleteView">{{ $t("viewRegistration.close") }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
      </v-dialog>
      <v-col md="12">
        <v-data-table
          :headers="membershipHeaders"
          :items="registrationCards"
          sort-by="name"
          class="elevation-1"
          dense
          :no-data-text="$t('membership.no_data_available')"
          :footer-props="{
            'items-per-page-text': $t('membership.items_per_page_text'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
        >
          <template v-slot:footer.prepend>
            <div class="passport-footer-actions">
              <v-btn :color="`${buttonColor}`" class="btn_next mr-3" @click="returnToDashboard">{{ $t("membership.return_to_dashboard") }}</v-btn>
              <v-btn :color="`${buttonColor}`" class="btn_next mr-3" @click="signUpForEvent">{{ $t("membership.sign_up_for_event") }}</v-btn>
              <v-btn :color="`${buttonColor}`" class="btn_next" @click="viewYourMemberships">{{ $t("membership.view_your_memberships") }}</v-btn>
            </div>
          </template>
          <template v-slot:[`item.view`]="{ item }">
            <v-icon small class="mr-2" @click="viewHistory(item)">fa far fa-credit-card</v-icon>
          </template>
          <template v-slot:item.firstName="{ item }">
            <span>{{item.firstName}} {{ item.lastName }}</span>
          </template>
          <template v-slot:item.validTo="{ item }">
            <span>{{ item.validTo | formatDateForHumans(false) }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import WarningAlert from "@/components/alert/WarningAlert";
import OrganizationService from "@/services/OrganizationService";
import RegistrationService from "@/services/RegistrationService";
import {
  VRow,
  VCol,
  VIcon,
  VBtn,
  VCardText,
  VCard,
  VDialog,
  VDataTable,
} from "vuetify/lib";
export default {
  components: {
    WarningAlert,
    VRow,
    VCol,
    VIcon,
    VBtn,
    VCardText,
    VCard,
    VDialog,
    VDataTable,
  },
  props: {
    step: Number,
    buttonColor: String,
    itemOrg: Object,
    registrationCards: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      membershipDataCard: false,
      viewRow: false,
    };
  },
  computed: {
    membershipHeaders() {
      return [
        {
            text: this.$t("membership.card"),
            value: "view",
            sortable: false
        },
        {
          text: this.$t("membership.name"),
          value: "firstName",
          sortable: true
        },
        { text: this.$t("membership.class"), value: "raceClass" },
        { text: this.$t("membership.race_num"), value: "number" },
        { text: this.$t("membership.membership_number"), value: "memberId" },
        {
          text: this.$t("membership.membership_expiration"),
          value: "validTo"
        },
      ];
    }
  },
  methods: {
    returnToDashboard() {
      this.$router.push('/dashboard');
    },
    async signUpForEvent() {
      try {
        let returnEvent = null;
        try {
          const stored = localStorage.getItem('member_reg_return_event');
          if (stored) {
            returnEvent = JSON.parse(stored);
            localStorage.removeItem('member_reg_return_event');
          }
        } catch (e) { /* localStorage may be unavailable */ }

        let organizationId = this.itemOrg ? this.itemOrg.id : null;
        if (!organizationId && this.registrationCards && this.registrationCards.length > 0) {
          organizationId = this.registrationCards[0].organizationId;
        }

        let promoterUserId = 0;
        if (returnEvent && returnEvent.promoterUserId) {
          promoterUserId = returnEvent.promoterUserId;
        }

        if (promoterUserId <= 0 && organizationId) {
          const orgPromResp = await OrganizationService.getOrganizationPromoters(organizationId);
          if (orgPromResp && orgPromResp.data && orgPromResp.data.success == 1 && orgPromResp.data.message) {
            promoterUserId = orgPromResp.data.message.usersID || 0;
          }
        }

        const promotersResp = await RegistrationService.getPromoterListDays(500);
        const promoters = promotersResp && promotersResp.data && promotersResp.data.success == 1 ? promotersResp.data.message : [];

        const baseStep = {
          promoters,
          promoterSel: null,
          events: [],
          eventSel: null,
          participants: [],
          partsSel: [],
          classE: [],
          brandsE: [],
          userId: 0,
          spectators: [],
          spectatorsSel: [],
          practicesSel: []
        };

        if (promoterUserId <= 0) {
          this.$store.commit("SET_DATA_STEP", { ...baseStep, step: 1 });
          this.$router.push({ name: "RegisterEventLegacy" });
          return;
        }

        const promoterSel = promoters.find((p) => p.userID == promoterUserId);
        if (!promoterSel) {
          this.$store.commit("SET_DATA_STEP", { ...baseStep, step: 1 });
          this.$router.push({ name: "RegisterEventLegacy" });
          return;
        }

        const eventResp = await RegistrationService.getEventsByPromoter({
          id: promoterUserId,
          days: 500,
          limit: 50,
          user: 0,
          bGetEventDescription: false
        });
        const events = eventResp && eventResp.data && eventResp.data.success == 1 ? eventResp.data.message : [];

        let eventSel = null;
        if (returnEvent && returnEvent.eventId && events.length > 0) {
          eventSel = events.find((e) => e.id == returnEvent.eventId) || null;
        }

        this.$store.commit("SET_DATA_STEP", {
          ...baseStep,
          step: eventSel ? 3 : 2,
          promoterSel,
          events,
          eventSel,
        });

        this.$router.push({ name: "RegisterEventLegacy" });
      } catch (error) {
        this.$router.push({ name: "RegisterEventLegacy" });
      }
    },
    viewYourMemberships() {
      this.$router.push('/membership');
    },
    viewHistory(item) {
      this.viewRow =  true;
      const datePeriod = item.validFrom.length > 0 ? `${this.$options.filters.formatDateForHumans(item.validFrom,false)} to ${this.$options.filters.formatDateForHumans(item.validTo,false)}` : this.$t("common.not_available");
      this.membershipDataCard = {
        ...item,
        organizationName: (!item.ocname && item.ocname == '') ? this.$t("common.not_available") : item.ocname,
        membershipPeriod: item.life ? item.validTo : datePeriod,
        membershipNumber: (!item.memberId && item.memberId == '') ? this.$t("common.not_available") : item.memberId,
        racingType: (!item.racingType && item.racingType == '') ? this.$t("common.not_available") : item.racingType,
        className: (!item.raceClass && item.raceClass == '') ? this.$t("common.not_available") : item.raceClass,
        raceNumber: (!item.number && item.number == '') ? this.$t("common.not_available") : item.number,
        token: (!item.token && item.token == '') ? this.$t("common.not_available") : item.token,
        name:  (item.firstName == '') ? this.$t("common.not_available") : item.firstName + " " + item.lastName
      };
    },
    printCard(){
      let contents = document.getElementById("printMe").innerHTML;
      document.body.color = "#FFF";
      let frame1 = document.createElement("iframe");
      frame1.name = "frame1";
      frame1.style.position = "absolute";
      frame1.style.top = "-10000000px";
      document.body.appendChild(frame1);

      let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document: frame1.contentDocument;
      frameDoc.document.open();
      frameDoc.document.write(contents);
      frameDoc.document.close();
      setTimeout(function(){
        window.frames["frame1"].focus();
        window.frames["frame1"].print();
        document.body.removeChild(frame1);
      }, 500);
      return false;
    },
    closeDeleteView() {
      this.viewRow = false;
    },
  },
};
</script>
<style>
.membership .v-data-table-header,
.membership .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color: white !important;
}
.btn2{
  height: 28px !important;
  text-transform: capitalize;
  margin-left: 5px;
  margin-bottom: 0 !important;
}
.partImg{
  width: 40px;
  border-radius: 50%;
  height: 40px;
}
.partSpan{
  color: #000;
  position: absolute;
  top: 10px;
  left: 60px;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}
.bcard{
  padding-top: 25px;
}
.bcard p{
  margin-bottom: 0;
}
.cardTitle2{
  background: #45615f;
}
.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  background: #cccccc !important;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td{
  cursor: pointer;
}
.passport-footer-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 8px 0;
}
.bg_row{
    background-image: url('~@/assets/images/BackGroundImage.png');
    background-size: contain !important;
    background-repeat: no-repeat !important;
    padding-top: 70px;
    padding-bottom: 70px;
    min-width: 480px;
}
#printMe1 {
  overflow-x: auto;
}
@media print{
    @page{
      size: auto;
      margin: 0mm;
    }
    html{
      background-color: #FFFFFF;
      margin: 0px;
    }
    body{
      margin: 10mm 15mm 10mm 15mm;
    }
}
</style>